export default "__VITE_ASSET__BsZRnzdC__"